(() => {
  const initHighlightBar = (root) => {
    if (
      !root ||
      root.dataset.tsHighlightsReady === 'true'
    ) {
      return;
    }

    const variantDataEl =
      root.querySelector(
        '[data-ts-highlight-variants]'
      );

    if (!variantDataEl) {
      return;
    }

    let variants = {};

    try {
      variants = JSON.parse(
        variantDataEl.textContent || '{}'
      );
    } catch (error) {
      console.warn(
        'TS Product Highlights: could not parse variant metafield data.',
        error
      );

      return;
    }

    const readSpeedEl =
      root.querySelector(
        '[data-ts-highlight-read-speed]'
      );

    const interfaceEl =
      root.querySelector(
        '[data-ts-highlight-interface]'
      );

    const warrantyEl =
      root.querySelector(
        '[data-ts-highlight-warranty]'
      );


    /* ==========================================================
       UPDATE HIGHLIGHTS
       ========================================================== */

    const update = (variantId) => {
      if (!variantId) {
        return;
      }

      const data =
        variants[String(variantId)];

      /*
        Ignore variant-change events that belong
        to another product on the page.
      */
      if (!data) {
        return;
      }

      const readSpeed =
        String(
          data.readSpeed || ''
        ).trim();

      const interfaceValue =
        String(
          data.interface || ''
        ).trim();

      const warranty =
        String(
          data.warranty || ''
        ).trim();


      /*
        Current behavior:
        hide the whole highlight section if any
        required specification is missing.
      */
      const complete =
        Boolean(
          readSpeed &&
          interfaceValue &&
          warranty
        );

      root.hidden =
        !complete;

      if (!complete) {
        return;
      }

      if (readSpeedEl) {
        readSpeedEl.textContent =
          readSpeed;
      }

      if (interfaceEl) {
        interfaceEl.textContent =
          interfaceValue;
      }

      if (warrantyEl) {
        warrantyEl.textContent =
          warranty;
      }
    };


    /* ==========================================================
       CURRENT VARIANT
       ========================================================== */

    const getCurrentVariantId =
      () => {
        const productId =
          root.dataset.productId;

        const productInfo =
          document.querySelector(
            `product-info[data-product-id="${productId}"]`
          ) ||
          document.querySelector(
            'product-info'
          );

        const idInput =
          productInfo?.querySelector(
            'form[action*="/cart/add"] input[name="id"]'
          ) ||
          productInfo?.querySelector(
            'input[name="id"]'
          );

        return (
          idInput?.value ||
          null
        );
      };


    root.dataset.tsHighlightsReady =
      'true';


    /* ==========================================================
       INITIAL LOAD
       ========================================================== */

    const currentVariantId =
      getCurrentVariantId();

    if (currentVariantId) {
      update(
        currentVariantId
      );
    }


    /* ==========================================================
       DAWN VARIANT CHANGE
       ========================================================== */

    if (
      typeof subscribe === 'function' &&
      typeof PUB_SUB_EVENTS !== 'undefined' &&
      PUB_SUB_EVENTS.variantChange
    ) {
      subscribe(
        PUB_SUB_EVENTS.variantChange,
        (event) => {
          const variantId =
            event?.data?.variant?.id;

          if (
            variantId &&
            variants[String(variantId)]
          ) {
            update(
              variantId
            );
          }
        }
      );
    }


    /* ==========================================================
       VARIANT PICKER FALLBACK
       ========================================================== */

    document.addEventListener(
      'change',
      (event) => {
        const picker =
          event.target.closest(
            'variant-selects'
          );

        if (!picker) {
          return;
        }

        const productInfo =
          picker.closest(
            'product-info'
          );

        if (
          productInfo &&
          String(
            productInfo.dataset.productId || ''
          ) !==
          String(
            root.dataset.productId || ''
          )
        ) {
          return;
        }

        window.setTimeout(
          () => {
            const variantId =
              getCurrentVariantId();

            if (variantId) {
              update(
                variantId
              );
            }
          },
          100
        );
      }
    );
  };


  /* ==========================================================
     INITIALIZATION
     ========================================================== */

  const initAll = (
    scope = document
  ) => {
    if (
      scope.matches?.(
        '[data-ts-product-highlights]'
      )
    ) {
      initHighlightBar(
        scope
      );
    }

    scope
      .querySelectorAll?.(
        '[data-ts-product-highlights]'
      )
      .forEach(
        initHighlightBar
      );
  };


  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        initAll(
          document
        );
      },
      {
        once: true
      }
    );
  } else {
    initAll(
      document
    );
  }


  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initAll(
        event.target
      );
    }
  );
})();